// React component
import { lazy, Suspense } from "react";
import { LazyLoadingAnimation } from "./Lazy";
const OdometerBase = lazy(() => import("./OdometerAsync"));
// ================================================================================================
export enum OdometerTheme {
    default = "default",
    minimal = "minimal",
    car = "car",
    plaza = "plaza",
    digital = "digital",
    slotMachine = "slot-machine",
    trainStation = "train-station"
}
// ------------------------------------------------------------------------------------------------
export interface OdometerProps {
    /**
     * Count is a simpler animation method which just increments the value,
     * use it when you're looking for something more subtle.
     */
    animationCount?: boolean;

    /**
     * Change how digit groups are formatted, and how many digits are shown after the decimal point
     * Format    -  Example
     * (,ddd)    -  12,345,678
     * (,ddd).dd -  12,345,678.09
     * (.ddd),dd -  12.345.678,09
     * ( ddd),dd -  12 345 678,09
     * d         -  12345678
     */
    format?: string;

    /**
     * Change how long the javascript expects the CSS animation to take
     */
    duration?: number;

    /**
     * Specify the theme (if you have more than one theme css file on the page)
     */
    theme: OdometerTheme;

    /**
     * The value
     */
    value: number;
}
// ------------------------------------------------------------------------------------------------
export var Odometer = (props: OdometerProps) => {
    return (
     <Suspense fallback={<LazyLoadingAnimation />}>
         <OdometerBase {...props} />
     </Suspense>
    );
}

// ================================================================================================